export const html = "<p>Roll dolma the Armenian way at Machanenc House.</p>\n";
export const leadHtml = "<p>Roll dolma the Armenian way at Machanenc House.</p>\n";
export const bodyHtml = "";
export const metaText = "Roll dolma the Armenian way at Machanenc House.";